<template>
  <div
    class="d-flex flex-column align-center"
    style="width: fit-content"
  >
    <v-card
      elevation="0"
      class="d-flex align-center pa-0"
      style="width: fit-content"
    >
      <span class="mr-2">SLA - Primeira Resposta</span>

      <v-chip-group
        v-model="slaTipoAlertaSelecionado"
        column
        @change="handleSelectSlaPrimeiraResposta"
      >
        <sla-badge-azul
          class="mr-2"
          :text="slasContadores.primeiraRespostaBadgeAzul.text"
          :value="slasContadores.primeiraRespostaBadgeAzul.value"
        />

        <sla-badge-verde
          class="mr-2"
          :text="slasContadores.primeiraRespostaBadgeVerde.text"
          :value="slasContadores.primeiraRespostaBadgeVerde.value"
        />

        <sla-badge-laranja
          class="mr-2"
          :text="slasContadores.primeiraRespostaBadgeLaranja.text"
          :value="slasContadores.primeiraRespostaBadgeLaranja.value"
        />

        <sla-badge-vermelho
          :text="slasContadores.primeiraRespostaBadgeVermelho.text"
          :value="slasContadores.primeiraRespostaBadgeVermelho.value"
        />
      </v-chip-group>
    </v-card>

    <v-card
      elevation="0"
      class="d-inline-flex align-center pa-0"
      style="width: fit-content"
    >
      <span class="mr-2">SLA - Finalização</span>

      <v-chip-group
        v-model="slaTipoAlertaFinalizacaoSelecionado"
        column
        @change="handleSelectSlaFinalizacao"
      >
        <sla-badge-azul
          class="mr-2"
          :text="slasContadores.finalizacaoBadgeAzul.text"
          :value="slasContadores.finalizacaoBadgeAzul.value"
        />

        <sla-badge-verde
          class="mr-2"
          :text="slasContadores.finalizacaoBadgeVerde.text"
          :value="slasContadores.finalizacaoBadgeVerde.value"
        />

        <sla-badge-laranja
          class="mr-2"
          :text="slasContadores.finalizacaoBadgeLaranja.text"
          :value="slasContadores.finalizacaoBadgeLaranja.value"
        />

        <sla-badge-vermelho
          :text="slasContadores.finalizacaoBadgeVermelho.text"
          :value="slasContadores.finalizacaoBadgeVermelho.value"
        />
      </v-chip-group>
    </v-card>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import SlaBadgeAzul from '@/components/sla-badge/SlaBadgeAzul.vue'
import SlaBadgeVerde from '@/components/sla-badge/SlaBadgeVerde.vue'
import SlaBadgeLaranja from '@/components/sla-badge/SlaBadgeLaranja.vue'
import SlaBadgeVermelho from '@/components/sla-badge/SlaBadgeVermelho.vue'
import SlaTipoEnum from '@/models/entities/sla/SlaTipoEnum'

export default {
  components: {
    SlaBadgeAzul,
    SlaBadgeVerde,
    SlaBadgeLaranja,
    SlaBadgeVermelho,
  },

  emits: ['update:sla'],

  props: {
    filaId: {
      type: Number,
      default: null,
    },
    slasContadores: {
      type: Object,
      required: true,
    },
  },

  setup(_, { emit }) {
    const slaTipoAlertaSelecionado = ref(null)
    const slaTipoAlertaFinalizacaoSelecionado = ref(null)

    function handleSelectSlaPrimeiraResposta(v) {
      slaTipoAlertaFinalizacaoSelecionado.value = null
      emit('update:sla', { slaTipoId: SlaTipoEnum.PrimeiraRespostaTicket, slaTipoAlertaId: v })
    }

    function handleSelectSlaFinalizacao(v) {
      slaTipoAlertaSelecionado.value = null
      emit('update:sla', { slaTipoId: SlaTipoEnum.FinalizacaoTicket, slaTipoAlertaId: v })
    }

    return {
      slaTipoAlertaSelecionado,
      slaTipoAlertaFinalizacaoSelecionado,
      handleSelectSlaPrimeiraResposta,
      handleSelectSlaFinalizacao,
    }
  },
}
</script>
